// extracted by mini-css-extract-plugin
export default {"details":"cookieList_details"};